import React from "react";
import { useContent } from "@thoughtbot/superglue";

type DemoContent = {
  message: string;
  nextPath: string;
};

export default function Hello() {
  const { message, nextPath } = useContent<DemoContent>();

  return (
    <main id="superglue-demo">
      <h1>{message}</h1>
      <a href={nextPath} data-sg-visit="true">
        Visit the second demo page
      </a>
    </main>
  );
}
